import React, { Component } from "react";

import PopoverMenu from "components/player/PopoverMenu";
import { dateToText } from "utils/helpers";
import styled from "styled-components";
import theme from "styles/theme";

const Container = styled.div`
  display: flex;
  column-gap: ${theme.spacing.unit * 1}px;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: ${theme.spacing.unit * 1}px;
  cursor: pointer;

  border-radius: 8px;

  ${(props) =>
    props.$isActive && `background-color: ${props.$activeBackgroundColor};`}

  &:hover {
    background-color: ${(props) => props.$hoverBackgroundColor};
  }
`;

const PlaylistItemTitle = styled.div`
  flex: 2;
  padding: 0 ${theme.spacing.unit * 1}px;

  font-size: 14px;
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;

  ${theme.container.small`
    font-size: 12px;
    font-family: Inter;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
  `};
`;

const PlaylistItemDuration = styled.div`
  font-size: 14px;
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;

  ${theme.container.small`
    font-size: 12px;
    font-family: Inter;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
  `};
`;

const StyledPopoverMenu = styled(PopoverMenu)`
  margin: 4px 0;

  visibility: hidden;

  ${Container}:hover & {
    visibility: visible;
  }
`;

export class PlaylistItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: false,
    };
  }

  handleToggleVisibleClick = async (e) => {
    const { isVisible } = this.state;

    e.stopPropagation();
    e.preventDefault();

    if (isVisible) {
      this.hide();
    } else {
      this.show();
    }
  };

  show = () => {
    this.setState({
      isVisible: true,
    });
  };

  hide = () => {
    this.setState({
      isVisible: false,
    });
  };

  handleGetEmbedLinkClick = (e) => {
    const { onGetEmbedLinkClick } = this.props;

    e.stopPropagation();

    onGetEmbedLinkClick();

    this.hide();
  };

  handleGoToFullClipClick = (e) => {
    const { onGoToFullClipClick } = this.props;

    e.stopPropagation();

    onGoToFullClipClick();

    this.hide();
  };

  handleKeyPress = (e) => {
    const { onClick } = this.props;

    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick();
    }
  };

  render() {
    const {
      className,
      isActive,
      onClick,
      onGetEmbedLinkClick,
      onGoToFullClipClick,
      jobClip,
      jobClipTrack,
    } = this.props;
    const { brandingData } = jobClip.employerProfile;

    const jobClipTrackStartSecs =
      jobClipTrack.recording.audios[0].secRangeStart || 0;
    const jobClipTrackEndSecs =
      jobClipTrack.recording.audios[0].secRangeEnd ||
      jobClipTrack.recording.audios[0].duration;

    const durationString = dateToText(
      jobClipTrackEndSecs - jobClipTrackStartSecs
    );

    return (
      <Container
        tabIndex={0}
        role={"button"}
        onKeyPress={this.handleKeyPress}
        className={className}
        $isActive={isActive}
        $hoverBackgroundColor={brandingData.secondaryStep3Color}
        $activeBackgroundColor={brandingData.secondaryStep2Color}
        onClick={onClick}
      >
        <PlaylistItemTitle>
          {jobClipTrack.title || jobClip.title}
        </PlaylistItemTitle>
        <PlaylistItemDuration>{durationString}</PlaylistItemDuration>
        <StyledPopoverMenu
          brandingData={brandingData}
          onGetEmbedLinkClick={onGetEmbedLinkClick}
          onGoToFullClipClick={onGoToFullClipClick}
        />
      </Container>
    );
  }
}

export default PlaylistItem;
